import { Img, Link } from "@react-email/components";

const SocialLink = ({ item }) => {
  const { id, label, number, url, imgSrc } = item;

  const getLinkProps = () => {
    switch (id) {
      case "call":
        return { href: `tel:${number}` };
      case "whatsapp":
        return { href: `https://wa.me/${number}` };
      default:
        return { href: url };
    }
  };

  return (
    <Link {...getLinkProps()} aria-label={label}>
      <Img className="w-5 mx-auto " src={imgSrc} alt={label} />
    </Link>
  );
};

export default SocialLink;
